export const CombinedChartTitle = ({ componentSize }) => {
  const style = {
    fontSize: 11,
    width: componentSize.current["CombinedChart"].width - 100,
    backgroundColor: "#ffffff",
  };
  // return (
  //   <div style={style}>
  //     <span style={{ fontSize: 12, fontWeight: 600 }}>Vector T1:</span>
  //     Stay aware of the vector outcome spectrum while using the histogram and
  //     the filters to identify certain vectors to study more closely.
  //   </div>
  // );
  return (
    <div style={style}>
      Explore and filter the Vector Strength Histogram outcome spectrum to
      identify certain Vector Sets to study more closely.
    </div>
  );
};

export const NoTitle = ({ componentSize, name }) => {
  const style = {
    height: 2,
    width: componentSize.current[name].width - 100,
  };
  return <div style={style}></div>;
};

export const FilterTitle = ({ componentSize, title, name }) => {
  const style = {
    fontSize: 12,
    fontWeight: 600,
    width: componentSize.current[name].width - 50,
    backgroundColor: "#ffffff",
  };
  return <div style={style}>{title}</div>;
};
